<script setup lang="ts">
import { computed } from 'vue';
import { useADialog } from '@Atoms';

const props = defineProps<{
  field?: any;
  oddRow?: boolean;
  rowData: any;
  settings?: any;
}>();

const { activeModal, activeModalProps, dialogVisibility, SYSTEM_MODALS } = useADialog();

const status = computed(() => {
  const isArchived = (props.rowData?.status || '').toLowerCase() === 'deleted';
  if (isArchived) return { label: 'shelters.status.archived', severity: 'danger' };

  if (!props.rowData?.profile) return { label: 'shelters.status.onboarding', severity: 'info' };

  return { label: 'shelters.status.active', severity: 'success' };
});

const isOnboarding = computed(() => status.value.label === 'shelters.status.onboarding');

function onSendWelcomeEmail() {
  const shelterId = props.rowData?._id?.$oid || props.rowData?._id;

  activeModalProps.value = {
    email: props.rowData?.admin_email,
    endpoint: '/api/admin/shelter/send-welcome-email',
    notifyError: ['shelters.sendWelcome.error'],
    notifySuccess: ['shelters.sendWelcome.success'],
    payload: { shelter_id: shelterId },
    throttle: true,
    title: 'shelters.sendWelcome.title',
  };
  activeModal.value = SYSTEM_MODALS.EMAIL_SENDER;
  dialogVisibility.value = true;
}
</script>

<template>
  <div class="flex items-center gap-2">
    <Tag
      class="w-fit text-[10px] font-semibold"
      :severity="status.severity"
      :value="$t(status.label)"
    />

    <Button
      v-if="isOnboarding"
      outlined
      v-tooltip.top="{ value: $t('shelters.tooltips.sendWelcome'), showDelay: 500 }"
      class="af-button w-9 border-none"
      icon="pi pi-send"
      severity="secondary"
      @click="onSendWelcomeEmail"
    />
  </div>
</template>
